import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { DEFAULT_DROPDOWN_ITEM, SPORT_SELECTOR_INPUT_LABEL } from "./constants";
import { ISportFilterProps } from "./types";
import { Sports } from "@material-ui/icons";

export const SportFilter = ({
  filter,
  filteredSports,
  handleFilterChange,
  isMeadSeason,
  coachsportId,
  schoolData,
  sports
}: ISportFilterProps) => {
  return (
    <FormControl>
      <InputLabel htmlFor="filter" shrink={true}>
        {SPORT_SELECTOR_INPUT_LABEL}
      </InputLabel>
      <Select
        style={{ width: "10em" }}
        inputProps={{
          id: "filter",
          name: "filter",
        }}
        value={filter}
        onChange={handleFilterChange}
        startAdornment={
          <InputAdornment position="start">
            <Sports />
          </InputAdornment>
        }
      >
        <MenuItem value="">
          <em>{DEFAULT_DROPDOWN_ITEM}</em>
        </MenuItem>
        {/* {filteredSports.map((sport) => ( */}
           {(isMeadSeason
            ? filteredSports.filter((sport) => 
                coachsportId.includes(sport.id) && ![72, 74, 73, 68].includes(sport.id)
              ) // Filter sports for midseason, excluding AD seasonal tags
            : schoolData?.isAdSurvey
              ? sports.filter((sport:any) =>
                  [72, 74, 73, 68].includes(sport.id) // Show only AD seasonal sports if isAdSurvey is true
                )
            : filteredSports.filter((sport) => ![72, 74, 73, 68].includes(sport.id)) // Exclude AD seasonal tags from end of season dashboard
          ).map((sport:any) => (
          <MenuItem key={sport.id} value={sport.name}>
            {sport.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/advanced-filters/components/sport-filter/SportFilter.tsx